import { inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first, tap } from 'rxjs';
import { fetchExtractionRules } from './extraction-rule.actions';
import { selectExtractionRules } from './extraction-rule.selectors';

export const extractionRuleResolver = () => {
  const store = inject(Store);
  return store.pipe(
    select(selectExtractionRules),
    tap((extractionRules) => {
      if (!extractionRules || extractionRules.length === 0) {
        store.dispatch(fetchExtractionRules());
      }
    }),
    first()
  );
};
